import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { withoutSystem, withSystem } from '../data/content';
export function CostOfInaction() {
  return <section aria-labelledby="costo" className="border-y border-line bg-canvasAlt" data-id="element-58" data-mp="2uxawcr9tgqoa">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-59" data-mp="2zxgglmdrbawc">
        <Reveal data-id="element-60" data-mp="2zukju1dnas9h">
          <h2 id="costo" className="font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-61" data-mp="34w9s599hgrtv">
            ¿Cuánto te cuesta seguir sin un sistema?
          </h2>
        </Reveal>

        <div className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-62" data-mp="3dpd3nc0kiulv">
          <Reveal className="flex h-full flex-col rounded-xl border border-line bg-surface p-5" data-id="element-63" data-mp="3iney0t3g2gcn">
            <h3 className="font-display text-base font-extrabold uppercase text-ink-muted" data-id="element-64" data-mp="3nmhtbltmh87f">
              Sin Mega Pack
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-65" data-mp="3skt01nomf2lf">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink-muted" data-id="element-66" data-mp="3egq1o0g8a81w">
                  <XIcon size={15} className="mt-0.5 flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-67" data-mp="39g21ao640ev0" />
                  <span data-id="element-68" data-mp="30i030gdrg0bf">{item}</span>
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.05} className="flex h-full flex-col rounded-xl border-2 border-accent bg-surface p-5" data-id="element-69" data-mp="111vtmhrsf1w">
            <h3 className="font-display text-base font-extrabold uppercase text-accent" data-id="element-70" data-mp="3ngwctfogevxw">
              Con CM Digital Pro
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-71" data-mp="3jerlinlhabef">
              {withSystem.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-ink" data-id="element-72" data-mp="jt2zd25hothn">
                  <CheckIcon size={15} className="mt-0.5 flex-shrink-0 text-success" strokeWidth={3} data-id="element-73" data-mp="ezi2xejjo7kk" />
                  <span data-id="element-74" data-mp="2eaciloxop6uq">{item}</span>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}